function LastRef() {
  return (
    <div>
      <li className="bullet-item">The year final: last time that the association was reported</li>
    </div>
  );
}

export default LastRef;
